/**
 * all user eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';
import { ChangeOfficeAndLangRequest } from '../model/changeOfficeAndLangRequest';
import { ChangeOfficeAndLangResponse } from '../model/changeOfficeAndLangResponse';
import { GetEncryptedLoginInfoResponse } from '../model/getEncryptedLoginInfoResponse';
import { Type } from '../model/type';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  protected basePath = 'http://localhost:8000';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * # 1. 概要 1. ALLDB(Tx)S2パーソナライズ情報のユーザ共通情報のオフィス/言語を更新する。  # 2. 処理内容 1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、エラーハンドリングAPI(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてアクセストークンの有効性確認およびTTL延長を行う。有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 1. リクエストパラメータについて、以下いずれかに合致する場合、エラー項目及びエラー内容と共にステータスコード400(Bad request)でエラー情報を返却し、本処理を中止とする。   1. 操作オフィスコード、言語情報が両方とも存在しない。   1. 操作オフィスコードが、ALLDB(マスタ)に存在しない。   1. 言語情報が、ALLDB(マスタ)に存在しない。 1. レスポンスのuuidをキーとしALLDB(Tx)S2パーソナライズ情報を更新する。 1. ステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 1. ALLDB(Tx)のS2パーソナライズ情報 |更新フィールド|更新内容|データ取得元|条件等| |:---|:---|:---|:---| |ユーザ共通情報の操作オフィスコード|操作オフィスコード|呼び出し元より渡された情報|| |ユーザ共通情報の言語情報|言語情報|呼び出し元より渡された情報|| |ユーザ共通情報のPOS国コード|POS国コード|操作オフィスコードをキーとしALLDB(マスタ)のオフィス情報のPOS国コード|| |ユーザ共通情報の通貨コード|通貨コード|操作オフィスコードをキーとしALLDB(マスタ)のオフィス情報の通貨コード|| |ユーザ共通情報のMETA用識別|META用識別|操作オフィスコードをキーとしALLDB(マスタ)のオフィス情報のMETA用識別|| |ユーザ共通情報のMETA用言語コード|META用言語コード|言語情報をキーとしALLDB(マスタ)の言語マスタの言語コード(メタデータ)|| |ユーザ共通情報のダミーオフィスフラグ|ダミーオフィスフラグ|操作オフィスコードをキーとしALLDB(マスタ)のオフィス情報のダミーオフィスフラグ||  # 4. 特記事項 なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changeOfficeAndLangPost(
    generated?: ChangeOfficeAndLangRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ChangeOfficeAndLangResponse>;
  public changeOfficeAndLangPost(
    generated?: ChangeOfficeAndLangRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ChangeOfficeAndLangResponse>>;
  public changeOfficeAndLangPost(
    generated?: ChangeOfficeAndLangRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ChangeOfficeAndLangResponse>>;
  public changeOfficeAndLangPost(
    generated?: ChangeOfficeAndLangRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/change-office-and-lang`;
    return this.httpClient.request<ChangeOfficeAndLangResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 1. ALLDB(Tx)S2パーソナライズ情報内のログイン情報を暗号化したものを返却する。  # 2. 処理内容 1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてアクセストークンの有効性確認およびTTL延長を行う。&lt;br&gt; 有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。 2. パラメータのTTL延長フラグに1(TTLを延長する)を指定して、ALLDB(Tx)のパーソナライズ情報を取得する。&lt;br&gt; ※ パラメータのTTL延長フラグに1(TTLを延長する)を指定して取得を行うと、TTLが24時間延長される。 3. パーソナライズ情報を元にCONNECTION_KINDを判別する。 4. 会員番号・企業ID・ログインユーザーIDに操作日時を付加する。 5. ログイン情報のvalueを暗号化する。 6. ログイン情報とステータスコード200(正常)を返却し処理を終了する。  # 3. データ更新内容 なし  # 4. 特記事項 なし
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEncryptedLoginInfoGet(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<GetEncryptedLoginInfoResponse>;
  public getEncryptedLoginInfoGet(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<GetEncryptedLoginInfoResponse>>;
  public getEncryptedLoginInfoGet(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<GetEncryptedLoginInfoResponse>>;
  public getEncryptedLoginInfoGet(
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/get-encrypted-login-info`;
    return this.httpClient.request<GetEncryptedLoginInfoResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
